import { useTranslation } from '../../../i18n/TranslationContext';

const serviceKeys = [
  { icon: 'ri-film-line', titleKey: 'services.content_production', descKey: 'services.content_production_desc', color: 'bg-primary-100 text-primary-700 hover:bg-primary-500 hover:text-background-50' },
  { icon: 'ri-live-line', titleKey: 'services.live_operations', descKey: 'services.live_operations_desc', color: 'bg-accent-100 text-accent-700 hover:bg-accent-500 hover:text-background-50' },
  { icon: 'ri-store-2-line', titleKey: 'services.commerce_support', descKey: 'services.commerce_support_desc', color: 'bg-primary-100 text-primary-700 hover:bg-primary-500 hover:text-background-50' },
  { icon: 'ri-shopping-bag-3-line', titleKey: 'services.shop_management', descKey: 'services.shop_management_desc', color: 'bg-accent-100 text-accent-700 hover:bg-accent-500 hover:text-background-50' },
];

export default function ServiceSection() {
  const { t } = useTranslation();

  return (
    <section id="services" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-16 md:mb-20">
          <p className="text-xs font-medium uppercase tracking-widest text-primary-500 mb-4">
            {t('nav.services')}
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-950 leading-tight max-w-3xl">
            {t('services.title')}
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {serviceKeys.map((svc, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl border border-foreground-100/60 p-8 md:p-10 flex flex-col group hover:border-primary-200/60 hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-6 transition-all duration-300 ${svc.color}`}>
                <i className={`${svc.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-950 mb-2.5">
                {t(svc.titleKey)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(svc.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}